// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__2kFLA","validationTips":"StatementDescriptor_validationTips__3z72w"};